import i18next from 'i18next';

export default function translate (data, isHtml) {
  if (!data) return data;
  if (typeof data === 'string') {
    if (!data.startsWith('http')) {
      data = i18next.t(data.replaceAll(':', '.'));
    } else {
      data = `<a href=${data}>${data}</a>`;
    }
  } else if (typeof data === 'string' || typeof data === 'number' || typeof data === 'boolean') {
    data = i18next.t(data);
  } else if (isHtml) {
    if (typeof data === 'object') {
      data = Object.keys(data).map((key) => '<div style="margin-left: 40px"><strong>' + i18next.t(key) + '</strong>: ' + translate(data[key]) + '</div>').join('<br>');
    } else if (Array.isArray(data)) {
      data = data.map((elem) => i18next.t(translate(elem))).join('<br>');
    }
  } else if (data.props && data.props.schema) {
    if (data.props.schema.title && data.props.schema.title !== undefined) {
      const text = data.props.schema.title;
      data.props.schema.title = i18next.t(text);
    }
    if (data.props.uiSchema && data.props.uiSchema['ui:placeholder'] && data.props.uiSchema['ui:placeholder'] !== undefined) {
      const text = data.props.uiSchema['ui:placeholder'];
      data.props.uiSchema['ui:placeholder'] = i18next.t(text);
    }
  }
  return data;
}
